import { ProductCardProps } from "./components/Card";

export const productsTypes: ProductCardProps[] = [
  {
    title: "Almendra",
    listProducts: [
      {
        title: "Hamburguesas",
        description: 
        
        `
            Nuestras Hamburguesas de Almendra son el resultado de años de experiencia en cocina vegetariana y la pasión por crear sabores únicos. Elaboradas con almendras seleccionadas, especias naturales y vegetales frescos, ofrecen una textura suave y un sabor auténtico que sorprende en cada bocado. Son una opción saludable, rica en proteínas y grasas buenas, perfectas para quienes buscan un estilo de vida balanceado sin renunciar al placer de comer delicioso.
        `
        ,


        photo: "/vegan/productos/almendra_hamburguesa.webp",
      },
      {
        title: "Queso fresco vegano",
        description: 
        `
            Nuestro Queso Fresco de Almendra es una creación original que combina la suavidad de las almendras con un delicado proceso artesanal. Su textura cremosa y sabor ligero lo convierten en una alternativa saludable y deliciosa para acompañar panes, ensaladas o frutas frescas. Rico en proteínas vegetales y grasas saludables, es ideal para quienes buscan un producto nutritivo, versátil y completamente libre de lácteos, sin renunciar al auténtico placer de un buen queso.
        `
        ,
        photo: "/vegan/productos/almendra_queso fresco.webp",
      },
      {
        title: "Queso fresco vegano con tomate",
        description: 
        `
            Nuestro Queso Fresco de Almendra con Tomates Deshidratados y Aceitunas es una combinación única que realza el sabor natural de la almendra con el toque intenso del tomate y la esencia mediterránea de las aceitunas. Suave, cremoso y lleno de matices, es perfecto para acompañar panes artesanales, ensaladas o como protagonista en una tabla de aperitivos. Nutritivo, libre de lácteos y elaborado con ingredientes vegetales, es una opción saludable y deliciosa para quienes buscan innovación y sabor en cada bocado.
        `
        ,
        photo: "/vegan/productos/almendra_queso fresco con tomate.webp",
      },
      {
        title: "Chorizo vegano",
        description: 
        `
            Nuestro Chorizo Vegano de Almendra es una propuesta innovadora que transforma la tradición en una experiencia 100% vegetal. Elaborado con almendras seleccionadas, especias naturales y un toque ahumado, ofrece una textura firme y un sabor intenso que recuerda al chorizo clásico, pero en versión saludable. Libre de carnes y conservadores, es rico en proteínas vegetales y grasas buenas. Ideal para acompañar desayunos, guisos o tapas, es una alternativa nutritiva y deliciosa para quienes buscan disfrutar sin renunciar al sabor.
        `,
        photo: "/vegan/productos/almendra_chorizo.webp",
      },
    ],
    health: "Las almendras aportan vitamina E, magnesio, fibra y grasas saludables que favorecen corazón y cerebro. Ayudan a controlar azúcar en sangre, mejoran salud intestinal, promueven saciedad para el control de peso y protegen células gracias a sus propiedades antioxidantes.",
    image: "/vegan/productos/almendra_Almond.webp",
    bgColor: "#E3B984",
    route: "/ourFood/almond"
  },
  {
    title: "Nueces",
    listProducts: [
      {
        title: "Hamburguesas",
        description: 
        `
        Nuestra Hamburguesa de Nuez combina el sabor crujiente de las nueces con especias naturales y vegetales frescos. Rica en proteínas y grasas saludables, ofrece una textura firme y un gusto único. Es la opción perfecta para quienes buscan una alternativa vegetariana nutritiva, deliciosa y lista para disfrutar.
        `,
        photo: "/vegan/productos/Nuts-pecan_burguer.webp",
      },
      {
        title: "Tacos",
        description: "Nuestros Tacos de Picadillo Vegano de Nuez ofrecen una propuesta deliciosa y diferente, elaborada con nueces finamente trituradas y sazonadas con especias naturales. Con una textura jugosa y un sabor lleno de carácter, son la opción perfecta para disfrutar de unos tacos nutritivos, saludables y totalmente vegetales.",
        photo: "",
      },
      {
        title: "Guisados",
        description: "Nuestros Guisados de Nuez reinventan la cocina tradicional con un toque completamente vegetal. Preparados con nueces sazonadas y especias naturales, ofrecen una textura firme y un sabor auténtico que recuerda a los guisos caseros. Son nutritivos, versátiles y perfectos para compartir en familia sin dejar de comer saludable.",
        photo: "",
      },
    ],
    image: "/vegan/productos/Nuts-pecan_Nuts.webp",
    bgColor: "#978572",
    route: "/ourFood/nuts",
    health: "Las nueces pecanas son un alimento funcional rico en nutrientes que favorece la salud cardiovascular, el control glucémico, la función cognitiva, la reducción de la inflamación y la modulación de la microbiota intestinal, siendo valiosas en nutrición pública y recuperación deportiva."
  },
  {
    title: "Portobello",
    listProducts: [
      {
        title: "Hamburguesas",
        description: "Nuestras Hamburguesas de Portobello destacan por su textura jugosa y sabor intenso, gracias al característico perfil del hongo portobello combinado con especias naturales. Son una alternativa saludable, rica en nutrientes y perfecta para disfrutar en un pan artesanal o como plato fuerte lleno de sabor y frescura.",
        photo: "/vegan/productos/Portobello_burger.webp",
      },
      {
        title: "Tacos",
        description: "Nuestros Tacos de Portobello Salteado combinan la suavidad del hongo portobello con especias naturales y un salteado ligero que realza su sabor. Jugosos, nutritivos y llenos de aroma, son una opción ideal para quienes buscan una experiencia vegetariana auténtica y deliciosa, perfecta para cualquier ocasión.",
        photo: "",
      },
      {
        title: "Guisados",
        description: "Nuestros Guisados de Portobello ofrecen una propuesta vegetariana sabrosa y nutritiva, elaborada con portobello fresco salteado y especias naturales que resaltan su sabor único. Con una textura jugosa y versátil, son ideales para acompañar tortillas, arroces o servir como plato principal lleno de aroma y frescura.",
        photo: "",
      },
    ],
    image: "/vegan/productos/Portobello_portobello.webp",
    bgColor: "#C39657",
    route: "/ourFood/portobello",
    health: "Los hongos portobello son una fuente vegetal baja en calorías, rica en vitaminas del grupo B, minerales como potasio, selenio y cobre, además de antioxidantes que apoyan la salud del corazón, sistema inmune, intestino y cerebro."
  },
  {
    title: "Nuez con portobello",

    listProducts: [
      {
        title: "Hamburguesas",
        description: "Nuestras Hamburguesas de Nuez con Portobello combinan lo mejor de ambos ingredientes: la textura crujiente de la nuez y el sabor jugoso del portobello. Sazonadas con especias naturales, ofrecen un perfil único, nutritivo y delicioso, perfecto para quienes buscan una alternativa vegetariana innovadora y llena de carácter.",
        photo: "/vegan/productos/Nuts with portobello_burger.webp",
      },
      {
        title: "Tacos",
        description: "Nuestros Tacos de Picadillo de Nuez con Portobello ofrecen una combinación perfecta de textura y sabor. La nuez aporta un toque crujiente, mientras que el portobello añade jugosidad y profundidad. Sazonados con especias naturales, son una opción vegetariana deliciosa, nutritiva y lista para disfrutar en cada bocado.",
        photo: "",
      },
      {
        title: "Guisados",
        description: "Nuestro Guisado de Nuez con Portobello une la textura firme de la nuez con la jugosidad del portobello en una receta llena de sabor y tradición. Sazonado con especias naturales, es un platillo nutritivo, versátil y completamente vegetariano, ideal para disfrutar en familia cualquier día de la semana.",
        photo: "",
      },
    ],
    image: "/vegan/productos/Nuts with portobello_nuts with portobello.webp",
    bgColor: "#56461D",
    route: "/ourFood/nutsportobello",
    health: "Los hongos portobello y las nueces aportan fibra y proteínas que benefician el corazón, además de vitaminas, minerales y grasas saludables como omega-3. Juntos ofrecen una alternativa vegetal saciante, con texturas complementarias, efecto antiinflamatorio y apoyo a la salud intestinal."
  },
  {
    title: "Jamaica con nuez",

    listProducts: [
      {
        title: "Hamburguesas",
        description: "Nuestras Hamburguesas de Nuez con Flor de Jamaica combinan la crocancia natural de la nuez con el sabor único y ligeramente ácido de la jamaica cocinada. Con especias seleccionadas, ofrecen un perfil fresco, nutritivo y diferente, ideal para quienes buscan una opción vegetariana innovadora y llena de carácter.",
        photo: "/vegan/productos/Jamaica with nuts_burger.webp",
      },
      {
        title: "Tacos",
        description: "Nuestros Tacos de Picadillo de Nuez con Jamaica son una propuesta fresca y original. La nuez aporta textura y cuerpo, mientras que la jamaica cocinada brinda un toque ácido y vibrante. Sazonados con especias naturales, resultan en un platillo vegetariano delicioso, nutritivo y lleno de sabor auténtico.",
        photo: "",
      },
      {
        title: "Guisados",
        description: "Nuestros Guisados de Nuez con Jamaica ofrecen una mezcla equilibrada entre la textura firme de la nuez y el toque ácido y aromático de la flor de jamaica cocinada. Preparados con especias naturales, son un platillo vegetariano nutritivo, casero y lleno de sabor que conquista en cada porción.",
        photo: "",
      },
    ],
    image: "/vegan/productos/Jamaica with nuts_nuts with jamaica.webp",
    bgColor: "#D55E64",
    route: "/ourFood/nutsjamaica",
    health: "Los hongos portobello y las nueces combinan beneficios al aportar fibra y proteínas que favorecen la salud cardiovascular, junto con vitaminas, minerales y grasas saludables como omega-3. Esta mezcla ofrece una alternativa vegetal saciante, con efectos antiinflamatorios y mejora de la salud intestinal."
  },
  {
    title: "Garbanzo",
    listProducts: [
      {
        title: "Tofu",
        description: "Nuestro Tofu de Garbanzo es una alternativa vegetal ligera y nutritiva, elaborado de manera artesanal a base de garbanzos. Suave, versátil y rico en proteínas, es perfecto para saltear, acompañar ensaladas o integrar en guisos, ofreciendo una opción saludable y deliciosa para tu cocina diaria.",
        photo: "/vegan/productos/chickpea_tofu_full.webp",
      },
      {
        title: "Hummus",
        description: "Nuestro Hummus es una crema suave y nutritiva elaborada con garbanzos, tahini, aceite de oliva y un toque de especias naturales. Cremoso y lleno de sabor, es perfecto como dip, acompañamiento o para untar, ofreciendo una opción saludable y deliciosa en cualquier ocasión.",
        photo: "",
      },
      {
        title: "Tofu marinado en pesto",
        description: "Nuestro Tofu de Garbanzo Marinado en Pesto combina la suavidad del tofu artesanal de garbanzo con el frescor del pesto hecho con hierbas y especias naturales. Versátil, aromático y rico en proteínas, es perfecto para saltear, acompañar ensaladas o servir como un plato vegetariano lleno de carácter.",
        photo: "",
      },
    ],
    image: "/vegan/productos/chickpea_chickpea.webp",
    bgColor: "#BF773A",
    route: "/ourFood/chickpea",
    health: "Los garbanzos brindan importantes beneficios para la salud gracias a su alto contenido de fibra, proteínas, vitaminas y minerales (hierro, magnesio y zinc). Favorecen corazón, digestión, control glucémico, peso saludable, salud ósea e inmunidad con acción antioxidante.",
  },
  {
    title: "Vegetales",
    listProducts: [
      {
        title: "Tortitas",
        description: "Nuestras Tortitas de Vegetales son pequeñas hamburguesas llenas de color y sabor, elaboradas con una mezcla de verduras frescas y especias naturales. Nutritivas, ligeras y versátiles, son ideales como snack, entrada o plato principal, ofreciendo una opción vegetariana práctica y deliciosa para cualquier momento del día.",
        photo: "/vegan/productos/vegetables_tortitas.webp",
      },
      {
        title: "Guisados",
        description: "Nuestros Guisados de Vegetales están preparados con una selección de verduras frescas salteadas y sazonadas con especias naturales. Llenos de color, aroma y nutrientes, son una opción vegetariana casera, saludable y versátil, perfecta para acompañar tortillas, arroces o disfrutar como plato principal reconfortante.",
        photo: "",
      },
      {
        title: "Tacos",
        description: "Nuestros Tacos de Vegetales Guisados combinan verduras frescas salteadas con especias naturales, ofreciendo un sabor casero y lleno de color en cada bocado. Saludables, ligeros y versátiles, son la opción perfecta para disfrutar de una comida vegetariana deliciosa y reconfortante, ideal para cualquier ocasión.",
        photo: "",
      },
      {
        title: "Ensaladas",
        description: "Nuestras Ensaladas con Aderezos Especiales combinan vegetales frescos con mezclas únicas que realzan su sabor y aportan un toque original. Ligeras, nutritivas y llenas de color, son ideales como plato principal o acompañamiento, ofreciendo una experiencia fresca y deliciosa en cada bocado totalmente vegetariano.",
        photo: "",
      },

    ],
    image: "/vegan/productos/vegetables_Vegetables.webp",
    bgColor: "#F7B18C",
    route: "/ourFood/vegetables",
    health: "Los vegetales aportan vitaminas, minerales, fibra y antioxidantes esenciales que favorecen la salud integral. Ayudan a reducir presión arterial y colesterol, disminuyen el riesgo de enfermedades cardíacas, derrames y algunos cánceres, mejoran la digestión, fortalecen la inmunidad, cuidan piel y ojos, y apoyan el control de peso."
  },
  {
    title: "Seitan",
        listProducts: [
      {
        title: "Pastor vegano",
        description: "Nuestro Pastor Vegano con Seitán recrea el sabor tradicional con una receta 100% vegetal. El seitán marinado con especias y chiles aporta jugosidad y un toque auténtico, ideal para tacos, tortas o platos principales. Una opción deliciosa, nutritiva y libre de carne que conquista a todos.",
        photo: "/vegan/productos/Seitan_tacos.webp",
      },
      {
        title: "Guisados",
        description: "Nuestros Guisados con Seitán ofrecen una alternativa vegetal llena de sabor y textura. Preparados con seitán sazonado y cocinado con especias naturales, son nutritivos, versátiles y recuerdan a los guisos caseros. Una opción deliciosa y reconfortante para disfrutar en familia, totalmente libre de carne y saludable.",
        photo: "",
      },

      {
        title: "Chicharra vegana",
        description: "Nuestra Chicharra Vegana ofrece una textura crujiente y un sabor intenso gracias a su preparación con ingredientes vegetales y especias naturales. Perfecta para acompañar tacos, tortas o disfrutar sola como botana, es una opción innovadora, deliciosa y completamente libre de carne que sorprende en cada bocado.",
        photo: "",
      },
      {
        title: "Pozole vegano",
        description: "Nuestro Pozole Vegano con Seitán y Champiñones reinventa este clásico en una versión 100% vegetal. Preparado con granos de maíz, seitán sazonado y champiñones frescos, ofrece un caldo aromático, nutritivo y lleno de sabor. Una opción saludable y reconfortante, perfecta para compartir y disfrutar en cualquier ocasión.",
        photo: "",
      },
      {
        title: "Tamales",
        description: "Nuestros Tamales Veganos están elaborados con masa suave y rellenos de ingredientes vegetales sazonados con especias naturales. Cocidos al vapor, ofrecen un sabor auténtico y una textura esponjosa que los hace irresistibles. Son una alternativa saludable, nutritiva y deliciosa para disfrutar en familia o compartir en cualquier ocasión.",
        photo: "",
      },
    ],
    image: "/vegan/productos/Seitan_seitan.webp",
    bgColor: "#A16813",
    route: "/ourFood/seitan",
    health: "El seitán destaca por su alto contenido en proteínas que favorecen músculo y saciedad, bajo en grasa y colesterol que apoya la salud cardiovascular, y fibra que mejora la digestión. Aporta minerales como hierro y selenio, aunque no es apto para celíacos o sensibles al gluten."
  },
];